var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWlkn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#FFB82F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_1230",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 40,
    height: 40
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 20,
    fill: "#FFB627"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_1230)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 20,
    fill: "#FFB82F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.0002,
    cy: 39.9999,
    r: 15,
    stroke: "#FFF5D0",
    strokeWidth: 3.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9995 37.5V42C39.9995 43.933 38.4325 45.5 36.4995 45.5C34.5665 45.5 32.9995 43.933 32.9995 42V39.5",
    stroke: "#FFF2C3",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 35.4998V41.9998C47 43.9328 45.433 45.4998 43.5 45.4998C41.567 45.4998 40 43.9328 40 41.9998V37.4998",
    stroke: "#FFF2C3",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWlkn);
export default __webpack_public_path__ + "static/media/wlkn.0bdcbddf4a847efef8972306d82324d5.svg";
export { ForwardRef as ReactComponent };